var layout_default = {
  "layoutWrapper": "LRIFJ",
  "layout": "LmXEw",
  "designOnLayout": "P-WYy",
  "designOnCell": "CvxCp",
  "cell": "_8Xb4l",
  "mobile": "Ay9OM"
};
export {
  layout_default as default
};
//# sourceMappingURL=layout-scss.js.map
